import React from "react";
import { Box, Typography, Link, Divider, useTheme } from "@mui/material";

const Footer = () => {
  const theme = useTheme();
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();
  const formattedDate = currentDate.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  return (
    <Box
      component="footer"
      sx={{
        py: 2.5,
        px: 4,
        mt: "auto",
        borderTop: `1px solid ${theme.palette.divider}`,
        backgroundColor: theme.palette.mode === 'dark' ? theme.palette.background.paper : "#fafafa",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          justifyContent: "space-between",
          alignItems: { xs: "center", sm: "center" },
          gap: 2,
          maxWidth: 1400,
          mx: "auto",
        }}
      >
        <Typography
          variant="body2"
          sx={{
            color: theme.palette.text.secondary,
            fontSize: 13,
            fontWeight: 500,
          }}
        >
          © {currentYear} GH Foundation. All rights reserved. | {formattedDate}
        </Typography>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            alignItems: "center",
          }}
        >
          <Link
            href="mailto:info@ghf.org"
            variant="body2"
            sx={{
              textDecoration: "none",
              color: theme.palette.text.secondary,
              fontSize: 13,
              fontWeight: 500,
              transition: "all 0.2s",
              "&:hover": {
                color: theme.palette.primary.main,
              },
            }}
          >
            Support
          </Link>
          <Divider
            orientation="vertical"
            flexItem
            sx={{
              borderColor: theme.palette.divider,
              height: 16,
              my: "auto",
            }}
          />
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              fontSize: 13,
              fontWeight: 500,
            }}
          >
            Version 1.0.0
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Footer;
